import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-fandango',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Fandango icon</title><path d="M13.664 6.956L8.05 8.496 9.19 12.72l5.615-1.54L15.95 15.4l-5.615 1.49 1.093 4.224-5.615 1.49L4.42 17.54c.846-.995 1.194-2.386.846-3.728-.398-1.342-1.392-2.385-2.584-2.832L1.29 5.763 12.57 2.78zm7.106-.198L18.932.05 0 5.068l1.838 6.758c1.093.2 2.087 1.043 2.385 2.236.348 1.193-.1 2.385-.944 3.18l1.788 6.708L24 18.882l-1.79-6.708c-1.142-.2-2.086-1.043-2.434-2.236-.298-1.193.1-2.435.994-3.18z"/></svg>`,
    styles: []
})
export class SimpleIconsFandangoComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FF7300';
    @Input() className: string = 'simple-icons-fandango'
    constructor() {}
    ngOnInit(): void {}
}
